import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AuthProvider from "./context/AuthContext";
import ToastProvider from "./context/ToastContext";
import CommunityProvider from "./context/CommunityContext";
import NotificationProvider from "./context/NotificationContext";
import ConfirmProvider from "./context/ConfirmContext";
import ProtectedRoute from "./components/common/ProtectedRoute";
import ErrorBoundary from "./components/common/ErrorBoundary";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import UserProfile from "./pages/UserProfile";
import Communities from "./pages/Communities";
import CommunityDetail from "./pages/CommunityDetail";
import Jobs from "./pages/Jobs";
import Messages from "./pages/Messages";
import Admin from "./pages/Admin";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import SavedPosts from "./pages/SavedPosts";
import NotificationSettings from "./pages/NotificationSettings";
import ChangePassword from "./pages/ChangePassword";
import NotFound from "./pages/NotFound";
import ForceChangePassword from "./pages/ForceChangePassword";
import * as GameModule from "./pages/Game";

function Providers({ children }) {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CommunityProvider>
          <ToastProvider>
            <ConfirmProvider>{children}</ConfirmProvider>
          </ToastProvider>
        </CommunityProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Providers>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/profile/:userId" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
            <Route path="/bio" element={<Navigate to="/profile" replace />} />
            <Route path="/communities" element={<ProtectedRoute><Communities /></ProtectedRoute>} />
            <Route path="/communities/:id" element={<ProtectedRoute><CommunityDetail /></ProtectedRoute>} />
            <Route path="/jobs" element={<ProtectedRoute><Jobs /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/inbox" element={<Navigate to="/messages" replace />} />
            <Route path="/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
            <Route path="/courses/:id" element={<ProtectedRoute><CourseDetail /></ProtectedRoute>} />
            <Route path="/saved" element={<ProtectedRoute><SavedPosts /></ProtectedRoute>} />
            <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettings /></ProtectedRoute>} />
            <Route path="/settings/password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
            <Route path="/force-change-password" element={<ProtectedRoute><ForceChangePassword /></ProtectedRoute>}/>
            <Route path="/game" element={<GameModule.default />} />
          </Routes>
        </Providers>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
